// Copyright 2023 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import Sdk from "casdoor-js-sdk";

const sdkConfig = {
  // serverUrl: "http://10.6.25.38:17003",
  serverUrl: "https://ntgl.tlsyjxndc.com:18004",
  // serverUrl: "http://111.56.142.53:17005",
  // serverUrl: "http://10.164.15.31:18000",
  clientId: "4dc13c8f1c388bdd0860",
  organizationName: "application_door",
  appName: "fgw",
  redirectPath: "/callback",
};
const halo = "http://localhost:8090/apis/api.console.halo.run";

export const CasdoorSDK = new Sdk(sdkConfig);

export const isLoggedIn = () => {
  const token = getToken();
  return token !== null && token.length > 0;
};

export const setToken = (token) => {
  localStorage.setItem("accessToken", token);
};

export const getToken = () => {
  return localStorage.getItem("accessToken");
};

export const goToLink = (link) => {
  window.location.href = link;
};
// export const getUserinfo = ( ) => {
//     console.log(localStorage.getItem("accessToken"));
//     return CasdoorSDK.getUserInfo(localStorage.getItem("accessToken"));
// };
export const getUserinfo = () => {
  return CasdoorSDK.getUserInfo(getToken());
};
export const getUserProfileUrl = (userName, account) => {
  return CasdoorSDK.getUserProfileUrl(userName, account);
};
export const goToProfilePage = () => {
  window.location.assign(CasdoorSDK.getMyProfileUrl());
};

export const logout = () => {
  localStorage.removeItem("accessToken");
};
export const getPermssion = (token) => {
  return CasdoorSDK.parseAccessToken(token);
};
export const showMessage = (message) => {
  alert(message);
};

// export const getHalo = () => {
//     return "http://localhost:8090/apis/api.console.halo.run";
// };
export const getHalo = () => {
  return "https://ntgl.tlsyjxndc.com:18004/apis/api.console.halo.run";
};
export const getHaloUrl = () => {
  return "https://ntgl.tlsyjxndc.com:18004";
};
